<template>
  <el-tooltip
    class="item"
    effect="dark"
    placement="top-start"
    :content="tooltip">
    <router-link
      :to="{ name: 'user', params: { userId: userId }}"
      :class="{
        'user-avatar': true,
        'user-avatar--big': size === 'normal',
        'user-avatar--small': size === 'small',
        'user-avatar--is-online': contact.isOnline
      }">
      <!--
      <img
        class="user-mini-image"
        :src="contact.profilePic|defaultUserPic"
        :width="size"
        :height="size"
        style="border-radius: 50%" />
      -->
      <span
        class="avatar"
        :style="{ backgroundImage: 'url(&quot;' + $options.filters.defaultUserPic(contact.profilePic) + '&quot;)' }">
        <div class="online-status"></div>
      </span>

      <span v-if="showName" class="user-avatar__text">{{contact.displayName}}</span>
    </router-link>
  </el-tooltip>
</template>

<script>
// TODO: Merge with UserAvatar.vue ?

export default {
  props: {
    userId: {
      type: String,
      required: true
    },
    showName: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  mounted() {
    this.$api.contact_add_if_not_cached( this.userId );
  },
  computed: {
    tooltip() {
      let status = this.contact.isOnline
        ? 'online'
        : 'offline, last seen ' + this.$options.filters.fromNow(this.contact.lastSeen)

      if ( this.showName ) {
        return status
      } else {
        return this.contact.displayName + ', ' + status
      }
    },
    contact() {
      return this.$models.userContact.get_contact_by_id( this.userId ) || {
        displayName: 'loading...'
      }
    }
  },
}
</script>

<style>
.user-avatar.user-avatar--is-online .online-status {
  background: #4CAF50;
}
.user-avatar.user-avatar--big {
  text-align: center;
  margin-right: 1em;
}
.user-avatar.user-avatar--small .user-avatar__text {
  margin-left: 0.2em;
}
.user-avatar.user-avatar--big .user-avatar__text {
  display: block;
  font-size: 9pt;
}
.user-avatar--small .avatar {
  width: 16px;
  height: 16px;
  border: 2px solid #cd201f;
  /* fix positioning issue (chrome) */
  top: -2px;
  position: relative;
}
.user-avatar--small .online-status {
  display: none;
}
.user-avatar--small.user-avatar--is-online .avatar {
  border-color: #4CAF50;
}
</style>
